import {Link} from 'react-router-dom';
import Icon from '../Icon';
import KindTile from './KindTile';
import {kindInfo} from '../../lib/kinds';
import {memoryKicker} from '../../lib/memories';
import {Post} from '../../types';

// "This time last year" (DESIGN.md §5, design/screens/Main.dc.html): a label, then a card with
// no fill and a dashed border, a tilted polaroid on the left, the kicker in display type, the
// title and where. The dashed border and the polaroid say "memory"; nothing else uses them.
export default function MemoryCard({post, today}: {post: Post; today: string}) {
    const info = kindInfo(post.kind);
    const photo = post.photos[0]?.thumbUrl ?? post.photos[0]?.url ?? null;
    return (
        <section className="flex flex-col gap-2" aria-label="This time last year">
            <h2 className="band-label m-0 text-ink-2">This time last year</h2>
            <Link to="/memories" className="flex items-center gap-[14px] rounded-[18px] border-[1.5px] border-dashed border-line py-3 pl-3 pr-[14px] no-underline">
                <span className="shrink-0 -rotate-3 rounded-[3px] bg-raised p-1 pb-3 shadow-1">
                    {photo ? <img src={photo} alt="" loading="lazy" className="block h-14 w-16 object-cover saturate-[.7]" /> : <KindTile kind={post.kind} size={56} className="rounded-none" />}
                </span>
                <span className="flex min-w-0 flex-1 flex-col gap-[2px]">
                    <span className="font-display text-[13px] font-[650] text-ink-2">{memoryKicker(post.whenLocal, today)}</span>
                    <span className="truncate font-[650] leading-[1.3]">{post.title || info.label}</span>
                    <span className="truncate text-xs text-ink-2">{[info.label, post.place?.name].filter(Boolean).join(' · ')}</span>
                </span>
                <Icon name="chevron" size={18} className="shrink-0 text-ink-3" />
            </Link>
        </section>
    );
}
